
<div class="p-12">
  <p>Please see below for your files and folders containing your scheduled reports and documents</p>
</div>


<div class="p-2">
  <h4>Current path: <span class="click" (click)="fullResetPath()"><fa-icon [icon]="['fas', 'home']"></fa-icon>:/</span><span *ngFor="let item of currentPath; let i = index" (click)="resetPath(i)" class="click">{{item}}/</span></h4>
</div>


<div class="row mt-5 justify-content-center p-5" *ngIf="loading">
  <div class="spinner-border text-primary" role="status">
      <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
  </div>
</div>

<div class="row" *ngIf="!loading">
  <div class="col-12">
    <h4>Folders</h4>
  </div>
  <div class="col-12">

    <span *ngFor="let item of viewedFileStructure  | keyvalue: originalOrder">
      <span *ngIf="(item.value | json) != '{}'" class="p-2" style="line-height: 1.5em; text-align: center; float:left;">
        <span class="click" (click)="openFolder(item.key)">
          <fa-icon [icon]="['far', 'folder']" size="5x" [styles]="{'stroke': 'orange', 'color': 'orange'}"></fa-icon>
          <br/>
          {{item.key}}
        </span>
      </span>
    </span>

  </div>
</div>

<br /><br />

<div class="row" *ngIf="!loading">
  <div class="col-12">
    <h4>Files</h4>
  </div>
  <div class="col-12">

    <span *ngFor="let item of viewedFileStructure  | keyvalue: originalOrder">
      <span *ngIf="(item.value | json) == '{}'" class="click p-1" (click)="downloadFile(currentPath, item.key)" style="display:block">
        <fa-icon [icon]="['far', 'file']" size="lg" [styles]="{'stroke': 'orange', 'color': 'orange'}"></fa-icon>
        {{item.key}}
      </span>
    </span>

  </div>
</div>

<br /><br /><br />